<pgh-modal-window size="md plus">
  <div modal-close>
    <button mat-icon-button class="close-button mat-icon-button" sf-aria-label="Global_Close_Window" matDialogClose>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <h3 modal-title class="px-5 text-center">
    <adp-label labelKey="SPOE_LookupUser_Forgot_Account_Info_Title"></adp-label>
  </h3>
  <div modal-body class="mt-25 mb-25">
    <div class="pb-4">
      <div class="program-name pb-1"><adp-label labelKey="Global_Eprism_Product_Name"></adp-label></div>
      <div class="fw-normal fs-6"><adp-label labelKey="SPOE_LookupUser_Forgot_Account_Info_Description_Eprism"></adp-label></div>
    </div>
    <div class="pb-2">
      <div class="program-name pb-1"><adp-label labelKey="Global_Product_Name"></adp-label></div>
      <div class="fs-6"><adp-label labelKey="SPOE_LookupUser_Forgot_Account_Info_Description_Elita"></adp-label></div>
    </div>
  </div>
  <div modal-footer class="text-center">
    <button mat-flat-button color="accent" type="button" matDialogClose><adp-label labelKey="SPOE_LookupUser_Forgot_Account_Button_Label"></adp-label></button>
  </div>
</pgh-modal-window>
